// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CreateLoanDoc .form {
  margin-top: 30px;
}
.CreateLoanDoc .form-item-task-name .ant-form-item-control-input {
  min-height: 10px !important;
}
.CreateLoanDoc .form-doc-name {
  font-size: 16px !important;
  color: black !important;
}
.CreateLoanDoc .form-doc-name::placeholder {
  font-size: 16px !important;
}
.CreateLoanDoc .form-doc-name {
  font-size: 14px !important;
  font-weight: 400 !important;
  color: black !important;
}
.CreateLoanDoc .form-doc-name::placeholder {
  font-size: 14px !important;
  font-weight: 400 !important;
}
.CreateLoanDoc .form-doc-description {
  font-size: 14px !important;
  font-weight: 400 !important;
  font-style: italic !important;
  color: black !important;
}
.CreateLoanDoc .form-doc-description::placeholder {
  font-size: 14px !important;
  font-weight: 400 !important;
  font-style: italic !important;
}
.CreateLoanDoc .form-doc-expiration {
  width: 180px;
  border: none;
  padding: 0;
  box-shadow: none;
  border-color: white !important;
}
.CreateLoanDoc .form-doc-expiration input {
  font-size: 14px !important;
  font-weight: 400 !important;
  font-style: italic !important;
  color: black !important;
}
.CreateLoanDoc .form-doc-expiration::placeholder {
  font-size: 14px !important;
  font-weight: 400 !important;
  font-style: italic !important;
}
.CreateLoanDoc .form .doc-info .ant-form-item {
  margin-bottom: 0;
}
.CreateLoanDoc .form .doc-info .ant-form-item-control-input {
  min-height: 25px;
}
.CreateLoanDoc .form .placeholder {
  margin-top: 20px;
  font-style: italic;
}
.CreateLoanDoc .hide-doc {
  margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/scenes/Private/LoanList/LoanDetails/LoanDocuments/CreateLoanDoc.scss"],"names":[],"mappings":"AACE;EACE,gBAAA;AAAJ;AAGM;EACE,2BAAA;AADR;AAKI;EACE,0BAAA;EACA,uBAAA;AAHN;AAKM;EACE,0BAAA;AAHR;AAOI;EACE,0BAAA;EACA,2BAAA;EACA,uBAAA;AALN;AAOM;EACE,0BAAA;EACA,2BAAA;AALR;AASI;EACE,0BAAA;EACA,2BAAA;EACA,6BAAA;EACA,uBAAA;AAPN;AASM;EACE,0BAAA;EACA,2BAAA;EACA,6BAAA;AAPR;AAWI;EACE,YAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,8BAAA;AATN;AAWM;EACE,0BAAA;EACA,2BAAA;EACA,6BAAA;EACA,uBAAA;AATR;AAYM;EACE,0BAAA;EACA,2BAAA;EACA,6BAAA;AAVR;AAeM;EACE,gBAAA;AAbR;AAgBM;EACE,gBAAA;AAdR;AAkBI;EACE,gBAAA;EACA,kBAAA;AAhBN;AAoBE;EACE,gBAAA;AAlBJ","sourcesContent":[".CreateLoanDoc {\n  .form {\n    margin-top: 30px;\n\n    &-item-task-name {\n      .ant-form-item-control-input {\n        min-height: 10px !important;\n      }\n    }\n\n    &-doc-name {\n      font-size: 16px !important;\n      color: black !important;\n\n      &::placeholder {\n        font-size: 16px !important;\n      }\n    }\n\n    &-doc-name {\n      font-size: 14px !important;\n      font-weight: 400 !important;\n      color: black !important;\n\n      &::placeholder {\n        font-size: 14px !important;\n        font-weight: 400 !important;\n      }\n    }\n\n    &-doc-description {\n      font-size: 14px !important;\n      font-weight: 400 !important;\n      font-style: italic !important;\n      color: black !important;\n\n      &::placeholder {\n        font-size: 14px !important;\n        font-weight: 400 !important;\n        font-style: italic !important;\n      }\n    }\n\n    &-doc-expiration {\n      width: 180px;\n      border: none;\n      padding: 0;\n      box-shadow: none;\n      border-color: white !important;\n\n      input {\n        font-size: 14px !important;\n        font-weight: 400 !important;\n        font-style: italic !important;\n        color: black !important;\n      }\n\n      &::placeholder {\n        font-size: 14px !important;\n        font-weight: 400 !important;\n        font-style: italic !important;\n      }\n    }\n\n    .doc-info {\n      .ant-form-item {\n        margin-bottom: 0;\n      }\n\n      .ant-form-item-control-input {\n        min-height: 25px;\n      }\n    }\n\n    .placeholder {\n      margin-top: 20px;\n      font-style: italic;\n    }\n  }\n\n  .hide-doc {\n    margin-top: 10px;\n\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
